















import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    TypeParams,
    getIdsFromList,
    getDictionaryKeyByValue,
    ID,
    Method
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Button from '../../core/components/Button.vue';
import Combobox from '../../core/components/Combobox.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { ranchsCropTypeBulk } from '../ranch';
import { farmingTypeOptions, farmingTypesDict, getFarmingKeyByType, harvestFarmingTypeText, sowingFarmingTypeText } from '../helpers';
import { ranchTypes } from '../api/models';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        DeleteConfirmation
    }
})
export default class ModalGenerateGeofences extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ type: Function, required: true }) pendingGeofences: Method<boolean, void>
    @Prop({default: false}) isSowing: boolean;
    @Prop({default: 0}) allRanchsLength: number;
    @Prop({default: null}) companySelected: object | null;
    @Prop({default(){return []}}) selectedRanchs: Array<object>;
    @Prop({default(){return []}}) ranchIds: Array<ID>;
    confirmationDelete: boolean = false;
    pendingRequest: boolean = false;
    deleteModalTitle: string = 'Enviar chacras a Travel';
    deleteBody: string = '';
    geofencesSummary: Array<string> = [];

    mounted(){
        if(!hasElements(this.selectedRanchs) || this.ranchIds.length == this.allRanchsLength){
            this.deleteBody = `<b>Empresa:</b> ${this.companySelected && this.companySelected['name']}`;
            this.deleteBody += `<br><b>N° de Chacras:</b> ${this.ranchIds.length}`;
            this.deleteBody += `<br><small class='fs-13'>Si no hay ninguna chacra seleccionada, se tienen en cuenta las chacras filtradas en la tabla.</small>`;
            this.geofencesSummary = [
                `Se enviarán a Travel <b>${this.ranchIds.length} chacras</b> de <b>${this.isSowing ? 'Siembra' : 'Cosecha'}</b>.`,
            ]
            this.confirmationDelete = true;
        }else{

            this.generateGeofences();
        }
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: 10000
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    confirmAction(value){
        if(value){
            this.generateGeofences();
        }else{
            this.closeModal();
        }
        this.confirmationDelete = false;
    }

    generateGeofences() {
        this.pendingGeofences(true);
        this.showLoadingDialog('Generando geocercas...');
        let { ranch_ids, ranch_type } = this.getData;
        InsuranceServices.farmingCreateGeofences(
            ranch_ids,
            ranch_type
        ).then(res => {
            this.showSuccessLoadingDialog(
                res, 
                'Geocercas creadas correctamente'
            );
        }).catch(err => {
            this.showCatchLoadingDialog(err, 'No se pudieron crear las geocercas');
        }).finally(() => {
            this.pendingGeofences(false);
            this.closeModal();
        });
    }

    get formIsValid(){
        return true
    }

    get getRanchType(){
        let farmingTypeText = this.isSowing ? sowingFarmingTypeText: harvestFarmingTypeText
        return getDictionaryKeyByValue(this.$_getInsuranceProperties['ranch_types'], farmingTypeText) || 0 
    }

    get getData():{
        [TypeParams.RANCH_IDS]: Array<ID>,
        [TypeParams.RANCH_TYPE]: ranchTypes
    
    } {
        return {
            [TypeParams.RANCH_IDS]: this.ranchIds,
            [TypeParams.RANCH_TYPE]: Number(this.getRanchType) as number
        };
    }

    @Emit()
    closeModal() {}

    @Emit()
    updateFarmingDetail() {}

}
